var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.$isTab
    ? _c("div", { staticClass: "navbar-container" }, [
        _c("div", {
          staticClass: "overlay",
          class: { active: _vm.isShowSidebar },
          on: {
            click: function ($event) {
              return _vm.updateSidebar(false)
            },
          },
        }),
        _c(
          "div",
          { staticClass: "content", class: { "d-none": _vm.$isFullscreen } },
          [
            _c(
              "el-header",
              { staticClass: "ml-auto navbar" },
              [
                _c(
                  "a",
                  {
                    staticClass: "navbar-brand navbar-sidebar",
                    on: {
                      click: function ($event) {
                        return _vm.updateSidebar()
                      },
                    },
                  },
                  [
                    _c("font-awesome-icon", {
                      attrs: {
                        icon: "bars",
                        title: "menu",
                        "aria-hidden": "true",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "router-link",
                  { staticClass: "navbar-brand", attrs: { to: _vm.homeRoute } },
                  [
                    _vm.$userInformation.company &&
                    _vm.$userInformation.company.linkIcon
                      ? _c("img", {
                          staticClass: "navbar-img d-none d-lg-block",
                          attrs: {
                            src: _vm.$userInformation.company.linkIcon,
                            alt: _vm.companyName,
                          },
                        })
                      : _vm._e(),
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "navbar-nav ml-auto" },
                  [
                    _vm.$isAssignedDriverChanges
                      ? _c(
                          "span",
                          [
                            _c(
                              "el-tooltip",
                              {
                                staticClass:
                                  "mr-3 align-text-bottom save-warning",
                                attrs: {
                                  content: _vm.$t(
                                    "planning.tooltip.assignedDriverChanges"
                                  ),
                                  placement: "top",
                                },
                              },
                              [
                                _c("font-awesome-icon", {
                                  attrs: { icon: "user-friends" },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.$anyChanges
                      ? _c(
                          "span",
                          [
                            _c(
                              "el-tooltip",
                              {
                                staticClass:
                                  "mr-3 align-text-bottom save-warning",
                                attrs: {
                                  content: _vm.$t(
                                    "planning.tooltip.unsavedChanges"
                                  ),
                                  placement: "top",
                                },
                              },
                              [
                                _c("font-awesome-icon", {
                                  attrs: { icon: "save" },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-dropdown",
                      {
                        staticClass: "color-white cursor-pointer mr-4",
                        attrs: { trigger: "click" },
                        on: {
                          "visible-change": function ($event) {
                            _vm.isShowLang = !_vm.isShowLang
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "locale-text" },
                          [
                            _c("font-awesome-icon", {
                              attrs: { icon: "language", size: "lg" },
                            }),
                            _vm._v(" " + _vm._s(_vm.$i18n.locale) + " "),
                            _c("font-awesome-icon", {
                              staticClass: "ml-1 caret",
                              class: { open: _vm.isShowLang },
                              attrs: { icon: "caret-down" },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-dropdown-menu",
                          { attrs: { slot: "dropdown" }, slot: "dropdown" },
                          [
                            _c(
                              "el-dropdown-item",
                              {
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.setLang("en")
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("language.english")))]
                            ),
                            _c(
                              "el-dropdown-item",
                              {
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.setLang("sc")
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("language.simplifiedChinese"))
                                ),
                              ]
                            ),
                            _c(
                              "el-dropdown-item",
                              {
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.setLang("tc")
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("language.traditionalChinese"))
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-tooltip",
                      {
                        staticClass:
                          "mr-4 align-middle d-none d-md-inline-block cursor-pointer",
                        attrs: { content: _vm.$t("general.refreshBrowser") },
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: { icon: "sync" },
                          on: { click: _vm.refreshBrowser },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-tooltip",
                      {
                        staticClass:
                          "mr-4 align-text-top d-none d-md-inline-block",
                        attrs: {
                          content: _vm.$t("general.toggleFullscreen"),
                          placement: "top",
                        },
                      },
                      [
                        _c(
                          "span",
                          { on: { click: _vm.toggleFullscreen } },
                          [_c("fullscreen", { ref: "fullscreen" })],
                          1
                        ),
                      ]
                    ),
                    _vm.$isLogIn
                      ? [
                          _c(
                            "el-dropdown",
                            {
                              staticClass: "color-white cursor-pointer mr-3",
                              attrs: { trigger: "click" },
                              on: {
                                "visible-change": function ($event) {
                                  _vm.isShowUser = !_vm.isShowUser
                                },
                              },
                            },
                            [
                              _c(
                                "span",
                                [
                                  _c("font-awesome-icon", {
                                    staticClass: "mr-1",
                                    attrs: { icon: "user" },
                                  }),
                                  _c("font-awesome-icon", {
                                    staticClass: "ml-1 caret",
                                    class: { open: _vm.isShowUser },
                                    attrs: { icon: "caret-down" },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-dropdown-menu",
                                {
                                  attrs: { slot: "dropdown" },
                                  slot: "dropdown",
                                },
                                [
                                  _c(
                                    "el-dropdown-item",
                                    { attrs: { disabled: "" } },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$userInformation.user &&
                                              _vm.$userInformation.user.name
                                              ? _vm.$userInformation.user.name
                                              : "USER"
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "el-dropdown-item",
                                    {
                                      nativeOn: {
                                        click: function ($event) {
                                          _vm.$isDarkTheme = !_vm.$isDarkTheme
                                        },
                                      },
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        attrs: { icon: "palette" },
                                      }),
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("general.darkTheme")) +
                                          " "
                                      ),
                                      _c("el-switch", {
                                        staticClass: "ml-1 mb-1",
                                        attrs: { disabled: "" },
                                        model: {
                                          value: _vm.$isDarkTheme,
                                          callback: function ($$v) {
                                            _vm.$isDarkTheme = $$v
                                          },
                                          expression: "$isDarkTheme",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  !_vm.$isAdmin
                                    ? _c(
                                        "router-link",
                                        { attrs: { to: "/settings/" } },
                                        [
                                          _c(
                                            "el-dropdown-item",
                                            [
                                              _c("font-awesome-icon", {
                                                attrs: { icon: "wrench" },
                                              }),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t("general.settings")
                                                  ) +
                                                  " "
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c(
                                    "el-dropdown-item",
                                    {
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.logOutUser()
                                        },
                                      },
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        attrs: { icon: "sign-out-alt" },
                                      }),
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("logout.logout")) +
                                          " "
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
              ],
              1
            ),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }